import HotelCardTitleBlock from './HotelCardTitleBlock';

export default HotelCardTitleBlock;
